// components/Loader.js
import React from 'react';
import PropTypes from 'prop-types';

import { Box, CircularProgress } from '@mui/material';

const Loader = ({ shouldShowFooter }) => (
  <Box
    sx={{
      height: '100vh',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: !shouldShowFooter ? 'white' : '#121212',
    }}
  >
    <CircularProgress color="primary" />
  </Box>
);

export default Loader;

Loader.propTypes = {
  shouldShowFooter: PropTypes.string.isRequired,
};
